import React, { useEffect, useMemo, useRef } from 'react';
import { Modal, message } from 'antd';
import classnames, { Argument } from 'classnames/bind';
import { useLocalStore, useObserver } from 'mobx-react';
import { useMemoizedFn, useMount, useUpdateEffect } from 'ahooks';
import { useIntl } from '@@/plugin-locale/localeExports';
import Select from '../../../../components/PC/Select';
import clientModels from '@/client/models';
import { LanguageSetting } from '@/client/models/info';
import { popoStorage } from '@/utils/Bridge';

export interface Props {
  $c: (...args: Argument[]) => string;
  show: boolean;
  close: () => void;
  className?: string;
}
// 删除下拉框的title
function removeAntdSelectTitle() {
  setTimeout(
    () =>
      document
        .querySelectorAll('.ant-select-selection-item')
        .forEach((n) => n.setAttribute('title', '')),
    300
  );
}

export default function RecordLocaleSelect(props: Props) {
  const { info } = useLocalStore(() => clientModels);
  const { show, close, className, $c } = props;
  const { formatMessage } = useIntl();
  const $i = (mid: string) => {
    return formatMessage({ id: mid });
  };

  const setValue = useMemoizedFn((key: keyof LanguageSetting, value: string) => {
    info.setLanguageSetting(key, value);
    removeAntdSelectTitle();
  });

  useEffect(() => {
    popoStorage.get('record-languageSetting').then((value) => {
      if (value) {
        const languageSetting = JSON.parse(value);
        info.setLanguageSettingObj(languageSetting);
      }
    });
  }, []);

  useUpdateEffect(() => {
    popoStorage.set('record-languageSetting', JSON.stringify(info.languageSetting));
  }, [
    info.languageSetting.language,
    info.languageSetting.language2,
    info.languageSetting.translateTargetLanguage,
  ]);

  useEffect(() => {
    if (show) removeAntdSelectTitle();
  }, [show]);

  const languageOption = useMemo(() => {
    const auto = info.languageSetting.translateTargetLanguage
      ? [{ label: `${$i('AUTOMATICALLY_RECOGNIZED')}(Beta)`, value: 'auto' }]
      : [];
    return [
      ...auto,
      {
        label: '简体中文',
        value: 'zh-CHS',
      },
      {
        label: 'English',
        value: 'en',
      },
      {
        label: '日本語',
        value: 'ja',
      },
    ];
  }, [info.languageSetting.translateTargetLanguage]);

  return useObserver(() => (
    <Modal
      className={classnames($c('locale-modal'), className)}
      visible={show}
      onCancel={() => close()}
      mask={false}
      footer={null}
      closable={false}
    >
      <div className={$c('locale-wraper')}>
        <div className={$c('select-group')}>
          <div className={$c('title')}>{$i('TRANSCRIPTION_LANGUAGE')}</div>
          <Select
            dropdownClassName={$c('record-panel-select')}
            className={$c('select')}
            style={{ width: '100%' }}
            value={info.languageSettingParams.language}
            onChange={(e) => setValue('language', e)}
            options={languageOption}
          />
          {/* {!!info.languageSetting.translateTargetLanguage && <div className={$c('title')}>{$i('TRANSCRIPTION_LANGUAGE_WILL_BE_AUTOMATICALLY_DETECTED')}</div>} */}
        </div>
        <div className={$c('select-group')}>
          <div className={$c('title')}>{$i('TRANSLATE_INTO')}</div>
          <Select
            dropdownClassName={$c('record-panel-select')}
            className={$c('select')}
            style={{ width: '100%' }}
            value={info.languageSettingParams.translateTargetLanguage}
            onChange={(e) => {
              setValue('translateTargetLanguage', e);
            }}
            options={[
              {
                label: $i('NO_TRANSLATE'),
                value: '',
              },
              {
                label: '简体中文',
                value: 'zh-CHS',
              },
              {
                label: 'English',
                value: 'en',
              },
              {
                label: '日本語',
                value: 'ja',
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  ));
}
